export default __webpack_public_path__ + "static/media/8.278ba3bc.jpg";